export default __webpack_public_path__ + "static/media/Permissions.994d51d4.svg";